import { render, staticRenderFns } from "./general.vue?vue&type=template&id=5aa358c2&scoped=true&"
import script from "./general.vue?vue&type=script&lang=ts&"
export * from "./general.vue?vue&type=script&lang=ts&"
import style0 from "./general.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./general.vue?vue&type=style&index=1&id=5aa358c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa358c2",
  null
  
)

export default component.exports